import { COLORS } from '@btime/constants'
import { path } from 'ramda'
import React from 'react'

import { SmallText, Text } from '../../components/presentation/Text'
import { useOpenServiceOrderModal } from '../../utils/routes/modals/modalsActions'
import FlexGrid from '../../components/structure/FlexGrid'
import Icon from '../../components/shapes/Icon'
import Link from '../../components/actions/Link'

const getSubtitleSize = size => {
  switch (size) {
    case 'small':
      return 'xsmall'
    case 'xsmall':
      return 'xxsmall'
    default:
      return 'small'
  }
}

const ServiceOrderPresenter = ({ serviceOrder, size, fontSize, hideIcon, ...props }) => {
  const openModal = useOpenServiceOrderModal()
  if (!serviceOrder) return false

  const subtitleSize = getSubtitleSize(fontSize || size)
  const subtitle = path(['service', 'name'], serviceOrder)

  return (
    <Link block onClick={() => openModal(serviceOrder)} underlineOnHover>
      <FlexGrid justify="flex-start" gutter={0.15}>
        <Text size={fontSize} {...props}>
          {serviceOrder.yearlyId}
        </Text>
        {!hideIcon && <Icon name="BsSearch" color={COLORS.dark3} size="0.8rem" />}
      </FlexGrid>
      {subtitle && (
        <SmallText {...props} size={subtitleSize} color={COLORS.dark3}>
          {subtitle}
        </SmallText>
      )}
    </Link>
  )
}

export default ServiceOrderPresenter
